<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="form.contains('name')" class="col-12 col-lg">
			<label for="name" class="form-label theme-main-color fw-bold"
				>Libellé</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="name"
				name="name"
				formControlName="name"
				[ngClass]="{
					'is-invalid': name.invalid,
					'is-valid': name.dirty && name.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('description')" class="col-12 col-lg">
			<label for="description" class="form-label theme-main-color fw-bold"
				>Description</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				id="description"
				name="description"
				formControlName="description"
				[ngClass]="{
					'is-invalid': description.invalid,
					'is-valid': description.dirty && description.valid
				}"
			/>
		</div>
	</div>
	<div class="row my-4">
		<label for="permissions" class="form-label fw-bold">Permissions(s)</label>
		<div class="row">
			<div
				class="col-md-4 check"
				*ngFor="let permission of listPermission | orderBy : 'name' : 'asc'"
			>
				<div *ngIf="permission.id !== 0">
					<input
						type="checkbox"
						name="{{ permission.id }}"
						class="form-check-input"
						[value]="permission"
						[checked]="isPermissionCheck(permission)"
						[ngClass]="{
							'theme-main-color-check': isPermissionCheck(permission)
						}"
						(change)="updateSelectedPermission($event, permission)"
					/>
					<label class="ms-2 form-check-label text-dark">
						{{ permission.libelle }}
					</label>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="
					!form.valid ||
					!(isAddressDefault.value || isAddressSelected.value) ||
					isValidateButtonClicked.value
				"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
